import * as ActionTypes from './actionTypes.js';
var _ = require('lodash');

export default function attestationOwcsMessagesReducers(state = {}, action) {
    switch (action.type) {
        case ActionTypes.FETCH_OWCS_SUCCESS:
            return _.extend({}, state, action.payload);
        case ActionTypes.FETCH_OWCS_FAILED:
            return _.extend({}, state, action.payload);
        default:
            return state;
    }
}